import axios from 'axios';
import { useQuery } from '@tanstack/react-query';

import { useAuth } from '@App/components/AuthProvider/auth-provider.context';

function useUserDetails() {
  const { isLoggedIn } = useAuth();

  return useQuery({
    queryKey: ['user', 'user-details'],
    queryFn: async () => {
      const { data } = await axios.get('/api/user');
      return data;
    },
    enabled: isLoggedIn,
  });
}

export {
  useUserDetails,
};
